
import Swiper from 'swiper';
import { Navigation, Virtual, A11y, Autoplay } from 'swiper/modules';
import 'swiper/css';

const defaultOptions = {
	modules: [Navigation, Virtual, A11y, Autoplay],

	direction: 'horizontal',
	loop: true,
	speed: 1200,

	autoplay: {
		delay: 5000,
		disableOnInteraction: true,
	},
	slidesPerView: 1,
	spaceBetween: 16,
	grabCursor: true,
	
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},

	a11y: {
        prevSlideMessage: 'Forrige slide',
        nextSlideMessage: 'Næste slide',
    },
};

document.querySelectorAll('.testimonial-list-component .swiper').forEach(function (el) {
	var swiper = new Swiper(el, defaultOptions);
});
